(function () {
  function textOf(node) {
    return (node && node.textContent ? node.textContent : '').replace(/\s+/g, ' ').trim().toUpperCase();
  }

  function mountStyle() {
    if (document.getElementById('aeliza-desktop-nav-sweetspot-style')) return;

    var style = document.createElement('style');
    style.id = 'aeliza-desktop-nav-sweetspot-style';
    style.textContent = [
      '@media (min-width: 901px) {',
      '  .site-nav__left { gap: 1.4em !important; }',
      '  .site-nav__item--reflection-separator { display: none !important; }',
      '  .site-nav__item--reflection-link { margin-left: 0 !important; }',
      '  .site-nav__link--reflection-index { display: flex !important; gap: 0.28em !important; align-items: baseline !important; }',
      '  .site-nav__reflection-word--the,',
      '  .site-nav__reflection-word--reflection,',
      '  .site-nav__reflection-word--index { color: #2f6bff !important; }',
      '  .site-nav__link--sale { color: #ff0000 !important; }',
      '  .site-nav__subscribe { display: none !important; }',
      '}',
      '@media (max-width: 900px) {',
      '  .site-nav__item--reflection-separator,',
      '  .site-nav__item--reflection-link { display: none !important; }',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function buildReflectionItem() {
    var item = document.createElement('li');
    item.className = 'site-nav__item site-nav__item--reflection-link';

    var link = document.createElement('a');
    link.className = 'site-nav__link site-nav__link--reflection-index';
    link.href = '/pages/self-reflection';
    link.setAttribute('aria-label', 'THE REFLECTION INDEX');
    link.innerHTML =
      '<span class="site-nav__reflection-word site-nav__reflection-word--the">THE</span>' +
      '<span class="site-nav__reflection-word site-nav__reflection-word--reflection">REFLECTION</span>' +
      '<span class="site-nav__reflection-word site-nav__reflection-word--index">INDEX</span>';

    item.appendChild(link);
    return item;
  }

  function buildSaleItem() {
    var item = document.createElement('li');
    item.className = 'site-nav__item site-nav__item--sale';

    var link = document.createElement('a');
    link.className = 'site-nav__link site-nav__link--sale';
    link.href = '/collections/sale';
    link.textContent = 'SALE';

    item.appendChild(link);
    return item;
  }

  function updateDesktopNav() {
    var list = document.querySelector('.site-nav__left');
    if (!list || list.dataset.sweetspotNav === 'swapped') return;

    var items = Array.prototype.slice.call(list.children);
    var shopItem = null;

    items.forEach(function (item) {
      var label = textOf(item.querySelector('.site-nav__link, .site-nav__dropdown-link, button, a'));
      if (!shopItem && label === 'SHOP ALL') {
        shopItem = item;
      }
      item.remove();
    });

    list.innerHTML = '';
    if (shopItem) list.appendChild(shopItem);
    list.appendChild(buildSaleItem());
    list.appendChild(buildReflectionItem());

    list.dataset.sweetspotNav = 'swapped';
  }

  function init() {
    mountStyle();
    updateDesktopNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
